__turbopack_context__.v({
  "amount": "CartSubtotal-module-scss-module__ICnZHW__amount",
  "label": "CartSubtotal-module-scss-module__ICnZHW__label",
  "row": "CartSubtotal-module-scss-module__ICnZHW__row",
});
